import React, { useState, useContext } from 'react';
import { Paper, Button, Grid, Typography, InputLabel } from '@material-ui/core';
// import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import ForwardIcon from '@material-ui/icons/ArrowForwardIos'
import Loader from 'react-loader-spinner';

import Input from '../../components/Input';
import Alert from '../../components/Alert';

import { AuthContext } from '../../providers/Auth';

// import logo from '../../assets/img/logo.png';
import logoHori from '../../assets/img/logo-horizontal.png';
import loginBg from '../../assets/img/login-bg.jpg';
// import formBg from '../../assets/img/form-bg.png';

import "./styles.css";

export default function Login() {
    const classes = useStyles();

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const auth = useContext(AuthContext);
    const history = useHistory();

    const formik = useFormik({
        initialValues: {
            login: '',
            password: '',
        },
        onSubmit: async ({ login, password }, formik) => {
            await auth.signIn({ login, password }, (_, err) => {
                if (!err) {
                    formik.setSubmitting(false);

                    history.push('/dashboard');

                    return;
                }

                setMessage({
                    open: true,
                    variant: 'error',
                    text: err.error,
                });
            });
        },
    });

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    return (
        <>
            <Grid container className="fullScreen">
                <Grid container className='mainDiv'>
                    <Grid item xs={12} className={classes.leftSide}>
                        <svg
                            viewBox="0 0 1440 490"
                            xmlns="http://www.w3.org/2000/svg"
                            className={classes.backgroundSvg}
                            aria-hidden="true"
                            preserveAspectRatio="none"
                        >
                            <path d="M 0,500 L 0,0 C 111.25358851674642,91.23444976076554 222.50717703349284,182.46889952153109 315,187 C 407.49282296650716,191.53110047846891 481.22488038277527,109.35885167464116 563,93 C 644.7751196172247,76.64114832535884 734.5933014354066,126.09569377990431 844,146 C 953.4066985645934,165.9043062200957 1082.401913875598,156.25837320574163 1185,127 C 1287.598086124402,97.74162679425837 1363.799043062201,48.87081339712918 1440,0 L 1440,500 L 0,500 Z" stroke="none" strokeWidth="0" fill="#0693e3" fillOpacity="0.53" />
                            <path d="M 0,500 L 0,0 C 80.43062200956936,116.54545454545453 160.86124401913872,233.09090909090907 251,269 C 341.1387559808613,304.90909090909093 440.9856459330143,260.1818181818182 543,244 C 645.0143540669857,227.8181818181818 749.1961722488039,240.1818181818182 859,261 C 968.8038277511961,281.8181818181818 1084.2296650717703,311.0909090909091 1182,269 C 1279.7703349282297,226.9090909090909 1359.8851674641148,113.45454545454545 1440,0 L 1440,500 L 0,500 Z" stroke="none" strokeWidth="0" fill="#0693e3" fillOpacity="1" />
                        </svg>
                        {/* <Grid item xs={12} style={{
                            marginTop: '20px',
                        }}>
                            <img src={logoHori} alt="logo" className={classes.logo} />
                        </Grid> */}
                        {/*<Grid item style={{ padding: '20px', textAlign: 'right' }}>
                            <Typography variant='h5' style={{
                                color: '#fff'
                            }}>
                                <i>Powered by MC2 Performance Organizacional</i>
                            </Typography>
                        </Grid>*/}
                    </Grid>
                    <Grid item xs={12} className={classes.formWrapper}>
                        <Paper elevation={3} className={classes.formContainer} style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '15px'
                        }}>
                            <form onSubmit={formik.handleSubmit} className={classes.form}>
                                <img src={logoHori} alt="logo" className={classes.logo} width="500" />
                                <Typography variant="h5" style={{
                                    color: '#fff',
                                    textAlign: 'center',
                                    fontWeight: '600',
                                    fontSize: '1.8rem',
                                    fontFamily: 'Arial, sans-serif',
                                    letterSpacing: '3px',
                                }}>
                                    LOGIN
                                </Typography>
                                <InputLabel style={{
                                    color: '#cfe1ee',
                                    fontSize: '1.1rem',
                                    fontWeight: '500',
                                    marginBottom: '10px',
                                    marginTop: '20px',
                                    textAlign: 'left',
                                    marginLeft: '10px',
                                }} >
                                    Usuário
                                </InputLabel>
                                
                                <Input
                                
                                    className={classes.input}
                                    style={{
                                        ...{
                                            padding: 20,
                                            backgroundColor: '#06131f',
                                            borderRadius: 20,
                                            fontSize: '1.2rem',
                                            fontWeight: '400'
                                            
                                        },
                                    }}
                                    // label="Login"
                                    textFieldProps={{
                                        placeholder: 'Digite seu usuário',
                                        name: 'login',
                                        onChange: formik.handleChange,
                                        value: formik.values.login,
                                        autoComplete: 'username',
                                        fullWidth: true,
                                        required: true,
                                    }}
                                />
                                <InputLabel style={{
                                    color: '#cfe1ee',
                                    fontSize: '1.1rem',
                                    fontWeight: '500',
                                    marginBottom: '10px',
                                    marginTop: '10px',
                                    textAlign: 'left',
                                    marginLeft: '10px',
                                }} >
                                    Senha
                                </InputLabel>
                                <Input
                                    className={classes.input}
                                    style={{
                                        ...{
                                            padding: 20,
                                            backgroundColor: '#06131f',
                                            borderRadius: 20,
                                            fontSize: '1.2rem',
                                            fontWeight: '400',
                                        },
                                    }}
                                    // label="Password"
                                    textFieldProps={{
                                        placeholder: 'Digite sua senha',
                                        name: 'password',
                                        onChange: formik.handleChange,
                                        value: formik.values.password,
                                        autoComplete: 'current-password',
                                        type: 'password',
                                        fullWidth: true,
                                        required: true,
                                    }}
                                />
                                <Button
                                    disabled={formik.isSubmitting}
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    type="submit"
                                    className={classes.whiteButton}
                                >
                                    {
                                        formik.isSubmitting ? (
                                            <Loader type="Oval" color="#ffffff" height={25} width={25} />
                                        ) : (
                                            <Typography variant="subtitle" style={{ fontSize: '1rem', display: 'flex', fontWeight: '700' }}>
                                                ENTRAR 
                                            </Typography>
                                        )}
                                </Button>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
            {!!message.open && (
                <Alert
                    open={message.open}
                    autoHideDuration={6000}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    severity={message.variant}
                    onClose={closeMessage}
                >
                    {message.text}
                </Alert>
            )}
        </>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    formContainer: {
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.24)',
        backgroundColor: 'rgba(6, 19, 31, 0.65)',
        width: '100%',
        maxWidth: 520,
        borderRadius: 20,
        zIndex: 2,
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        border: '1px solid rgba(255, 255, 255, 0.14)',
        height: '650px',
        display: 'flex',
        
        justifyContent: 'space-between',
    },
    logoContainer: {
        textAlign: 'center',
    },
    logo: {
        // maxWidth: '65%',
        margin: 'auto',
        width: '80%',
    },
    form: {
        padding: theme.spacing(0, 3, 3, 3),
        width: '100%',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
    },
    input: {
        marginBottom: theme.spacing(2),
        border: '1px solid #21415d ',
        borderRadius: 20,
        overflow: 'hidden',
        '& .MuiInputBase-root': {
            borderRadius: 20,
        },
        '& .MuiInputBase-input': {
            color: '#ffffff',
            fontSpace: '1px',
            fontSize: '1.2rem'
        },
      
    },
    whiteButton: {
        marginTop: '20px',
        
        background: '#009bff',
        padding: '15px',
        textAlign: 'center',
        color: '#FFF',
        '&:active': {
            color: '#FFF',
        },
        borderRadius: 20,
        '&:hover': {
            background: '#007dcc',
            boxShadow: '0 0 10px #007dcc69',
            color: '#FFF',
            transition: 'all 0.3s ease-in-out',
        }
    },
    leftSide: {
        position: 'absolute',
        inset: 0,
        userSelect: 'none',
        opacity: '0.95',
        overflow: 'hidden',
    },
    formWrapper: {
        position: 'relative',
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: theme.spacing(2),
        width: '100%',
    },
    backgroundSvg: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        display: 'block',
        zIndex: 0,
        pointerEvents: 'none',
        opacity: 0.9,
    }
})); 
